/** AUTO GENERATED FROM "node ./src/utils/convert-icons.js". DO NOT TOUCH. **/
import React from 'react'
import classNames from 'classnames'


class Icon extends React.PureComponent {
  render () {
    const { className, svgRef, ...otherProps } = this.props
    return (
      <svg id="a052b7d2-2976-45b2-882d-1ba0410cd667" viewBox="0 0 47 47" fill="currentColor" className={classNames('nmx-icon', className)} ref={svgRef} {...otherProps}>
  <defs>
    <mask id="bcd84caa-aedc-47a6-adc1-47400650fdc9" x="13.15" y="8.19" width="23.76" height="14.99" maskUnits="userSpaceOnUse">
      <g id="bef8c0bb-db30-421b-a2c0-beb6ba1a8424">
        <polygon id="b5eec15f-36b6-4349-8daf-d4edebbbee5f" points="13.15 10.92 35.4 8.19 36.91 20.44 14.65 23.18 13.15 10.92" style={{fill: "#fff",fillRule: "evenodd"}}/>
      </g>
    </mask>
  </defs>
  <g id="a7c01668-4221-45f2-880e-f632c08e5425">
    <g id="a42eba9a-c151-4337-b875-9b442a167834">
      <g id="b33a7a28-99fd-4158-aee4-f1a122fbc421">
        <g id="f524d88d-aa18-444c-9d12-bc44a4d6c398">
          <path id="a8f359f4-a3c6-4a8a-a808-3fd5ffec8460" d="M23.5,46A22.5,22.5,0,1,0,1,23.5,22.5,22.5,0,0,0,23.5,46Z" style={{fill: "#edf0f3",stroke: "#fff",strokeWidth: "2px",fillRule: "evenodd"}}/>
          <circle id="f656b67d-9182-4efb-81e8-f11aa70b000b" cx="24" cy="23" r="18" style={{fill: "none",stroke: "#ffb81c",strokeWidth: "0.75px"}}/>
        </g>
        <g id="adeadba4-b815-410c-99dd-a2c6b518b374">
          <g id="b029e241-e445-468c-b5cc-07dc98f9d9f5">
            <line id="b434a8df-ac6e-4db5-ace1-f54140468e56" x1="32.97" y1="19.23" x2="24.43" y2="29.11" style={{fill: "none",stroke: "#0e497b",strokeLinecap: "round",strokeWidth: "0.5px"}}/>
            <line id="fe80e64c-7c3c-43a7-9bf6-c41404305f13" x1="15.93" y1="19.21" x2="24.43" y2="29.11" style={{fill: "none",stroke: "#0e497b",strokeLinecap: "round",strokeWidth: "0.5px"}}/>
            <line id="e81335fe-8f3e-46e8-9963-da4f2405a872" x1="28" y1="19.23" x2="24.5" y2="28.5" style={{fill: "none",stroke: "#0e497b",strokeLinecap: "round",strokeWidth: "0.5px"}}/>
            <line id="fac6cab0-4eb9-4f62-a7c8-090cb6199052" x1="20.59" y1="19" x2="24.43" y2="28.75" style={{fill: "none",stroke: "#0e497b",strokeLinecap: "round",strokeWidth: "0.5px"}}/>
          </g>
          <g id="f7b89baf-deb6-479d-88b8-89a58b3aa051">
            <line id="ab728e53-40af-436d-b28e-9537096466a4" x1="23" y1="29" x2="15" y2="19" style={{fill: "none"}}/>
            <line id="bef4e726-a274-4b9f-b3d8-677e772499c2" x1="24" y1="29" x2="28" y2="20" style={{fill: "none"}}/>
            <line id="b8c4695c-414d-49f8-9a28-53e1b62e4cba" x1="24" y1="29" x2="34" y2="21" style={{fill: "none"}}/>
            <g id="a95c1a05-bfb1-4a38-ba39-4989cfde4004">
              <g style={{mask: "url(#bcd84caa-aedc-47a6-adc1-47400650fdc9)"}}>
                <path id="e9e431e5-6aac-4136-bb8e-a78464adb071" d="M30.15,17.93a2.74,2.74,0,0,1,.64,0,3.36,3.36,0,0,1,1.84.84c-2.34-6.81-8.23-6.93-8.29-6.93-6,.19-7.83,5.25-8.26,6.83a3.27,3.27,0,0,1,2.24-.82A3.77,3.77,0,0,1,20.67,19l.61-.39a5,5,0,0,1,3.38-1.12A5.7,5.7,0,0,1,28,19.05a4,4,0,0,1,2.11-1.12m2.7,1.49a3.23,3.23,0,0,0-2.09-1.19,3.37,3.37,0,0,0-2.62,1.15.14.14,0,0,1-.2,0,5.63,5.63,0,0,0-3.3-1.6,4.69,4.69,0,0,0-3.2,1.07l-.71.46a.16.16,0,0,1-.19,0,4.41,4.41,0,0,0-1-.76,3,3,0,0,0-1.23-.35,3.16,3.16,0,0,0-2.38,1.06.15.15,0,0,1-.18,0,.17.17,0,0,1-.07-.17c0-.07,1.35-7.33,8.65-7.56.07,0,6.53.13,8.78,7.78a.17.17,0,0,1-.07.19h0A.14.14,0,0,1,32.85,19.42Z" style={{fill: "#0e497b",stroke: "#0e497b",strokeWidth: "0.2500000010493542px",fillRule: "evenodd"}}/>
              </g>
            </g>
            <path id="f0001809-24ac-4863-b5b6-da06154625f4" d="M24.34,30.5v.26h-.1a.76.76,0,0,0-.57.38.7.7,0,0,0-.06.35A.61.61,0,0,0,24,32a3,3,0,0,0,.32.12l.42.15a.2.2,0,0,1,.15.23.23.23,0,0,1-.22.22l-.17,0a.45.45,0,0,1-.44-.28l0-.1-.53.11a.86.86,0,0,0,.25.43.94.94,0,0,0,.57.23v.34h.34v-.33l.2,0a.75.75,0,0,0,.56-.36.6.6,0,0,0,.06-.45.63.63,0,0,0-.36-.44,4.29,4.29,0,0,0-.5-.19,1.88,1.88,0,0,1-.3-.12.15.15,0,0,1-.11-.11.25.25,0,0,1,.21-.32.42.42,0,0,1,.35.08.47.47,0,0,1,.14.18.25.25,0,0,1,0,.07l.47-.16a.81.81,0,0,0-.17-.29.89.89,0,0,0-.57-.26V30.5Z" style={{fill: "#fbb116",fillRule: "evenodd"}}/>
            <rect id="eb9d7aad-e242-46eb-b0e4-f271724ec9d9" x="19" y="29.5" width="11" height="5" style={{fill: "none",stroke: "#0e497b",strokeWidth: "0.5px"}}/>
          </g>
        </g>
      </g>
    </g>
  </g>
</svg>

    )
  }
}

Icon.displayName = 'MoneyParachuteWithBorderIcon'

export default Icon
